import { Fragment, useContext } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";

export const SubmitOrderNote = () => {
  const { shippingCode } = useContext(GlobalContext);
  return (
    <Fragment>
      {shippingCode == "TBA" && (
        <div className="courier-pickup-msg submit-order-note">
          <h4>Note</h4>
          <p>Your Order will be submitted as a quote.</p>
          <p>We will get back you shortly with freight changes.</p>
        </div>
      )}
    </Fragment>
  );
};
